import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DriversReportScheduleTypesChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.errors",
		title: "Schedules by Type",
		yAxisLabel: "Schedules (Count)"
	} ),

	computed: {
		totalScheduleData() {
			const nameIndexMap = {};

			return this.items.reduce( ( accumulator, driver ) => {
				driver.stats.schedules.forEach( schedule => {
					if ( nameIndexMap.hasOwnProperty( schedule.name ) ) {
						accumulator[nameIndexMap[schedule.name]].value += schedule.value;
					} else {
						accumulator.push( {
							name: schedule.name,
							value: schedule.value
						} );

						nameIndexMap[schedule.name] = accumulator.length - 1;
					}
				} );

				return accumulator;
			}, [] );
		},

		barData() {
			if ( this.item ) {
				return this.item.stats.schedules.map( data => data.value );
			}

			return this.totalScheduleData.map( scheduleType => scheduleType.value );
		},

		labels() {
			if ( this.item ) {
				return this.item.stats.schedules.map( data => data.name.split( " " ) );
			}

			return this.totalScheduleData.map( scheduleType => scheduleType.name.split( " " ) );
		}
	}
};
